const WP_API_BASE = process.env.REACT_APP_SIMULATION_API_PROXY_ENDPOINT;
const WP_API_BASE_DOCKER = process.env.REACT_APP_SIMULATION_API_PROXY_ENDPOINT_DOCKER;
/**
 * Send simulation data via WordPress REST API.
 */
const sendSimulationData = async (data) => {
    try {
        // console.log(`${WP_API_BASE}/storages-simulator/simulation`);

        const response = await fetch(`${WP_API_BASE}/storages-simulator/simulation`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data),
            signal: AbortSignal.timeout(120000)
        });

        // console.log('status', response.status);

        if (!response.ok) {
            throw new Error(`HTTP error ${response.status}`)
        }

        const text = await response.text();
        if (!text) {
            throw new Error('Empty response body.')
        }
        return JSON.parse(text);

    } catch (error) {
        console.error("Fehler beim Senden der Simulation:", error);
        throw error;
    }
};

/**
 * Fetch simulation data by ID.
 */
const fetchSimulationData = async (id, isDocker) => {
    if (!id) {
        console.error('no id given');
        return null;
    }

    try {
        const url = isDocker
            ? `${WP_API_BASE_DOCKER}/storages-simulator/simulation/data/simulation-result/new-storage/${id}`
            : `${WP_API_BASE}/storages-simulator/simulation/data/simulation-result/new-storage/${id}`;

        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            },
            signal: AbortSignal.timeout(120000)
        });

        if (!response.ok) {
            throw new Error(`HTTP error ${response.status}`)
        }

        const text = await response.text();
        if (!text) {
            throw new Error('Empty response body.')
        }
        return JSON.parse(text);

    } catch (error) {
        console.error("Fehler beim Abrufen der SimulationAPI:", error);
        throw error;
    }
};

/**
 * Fetch configurator data by ID.
 */
const fetchConfiguratorData = async (id, isDocker) => {
    if (!id) {
        console.error('no id given');
        return null;
    }

    try {
        const url = isDocker
            ? `${WP_API_BASE_DOCKER}/configurator-payload/${id}`
            : `${WP_API_BASE}/configurator-payload/${id}`;

        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            },
            signal: AbortSignal.timeout(120000)
        });

        if (!response.ok) {
            throw new Error(`HTTP error ${response.status}`)
        }

        const text = await response.text();
        if (!text) {
            throw new Error('Empty response body.')
        }
        return JSON.parse(text);

    } catch (error) {
        console.error("Fehler beim Abrufen der SimulationAPI:", error);
        throw error;
    }
};

/**
 * Get list of battery types.
 */
const getBatteryTypes = async () => {
    try {
        const response = await fetch(`${WP_API_BASE}/storages-simulator/simulation/data/system-config/battery-types`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            },
            signal: AbortSignal.timeout(120000)
        });

        if (!response.ok) {
            throw new Error(`HTTP error ${response.status}`)
        }

        const text = await response.text();
        if (!text) {
            throw new Error('Empty response body.')
        }
        return JSON.parse(text);

    } catch (error) {
        console.error("Fehler beim Abrufen der Battery Types:", error);
        throw error;
    }
};

/**
 * Get storage configuration list.
 */
const getStorageConfigList = async () => {
    try {
        const response = await fetch(`${WP_API_BASE}/storages-simulator/simulation/data/system-config/storage-config-list`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            },
            signal: AbortSignal.timeout(120000)
        });

        if (!response.ok) {
            throw new Error(`HTTP error ${response.status}`)
        }

        const text = await response.text();
        if (!text) {
            throw new Error('Empty response body.')
        }
        return JSON.parse(text);

    } catch (error) {
        console.error("Fehler beim Abrufen der Storage Config List:", error);
        throw error;
    }
};

/**
 * Upload files as JSON array.
 */
const uploadFiles = async (payload) => {
    try {
        const response = await fetch(`${WP_API_BASE}/storages-simulator/simulation/data/upload`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ files: payload }),
            signal: AbortSignal.timeout(120000)
        });

        if (!response.ok) {
            throw new Error(`HTTP error ${response.status}`)
        }

        const text = await response.text();
        if (!text) {
            throw new Error('Empty response body.')
        }
        return JSON.parse(text);

    } catch (error) {
        console.error("Fehler beim Upload:", error);
        throw error;
    }
};

/**
 * Upload files in MultiPart form (if needed later).
 * — WordPress route currently expects JSON — not form data — so this is identical to uploadFiles.
 */
const uploadFilesMultiPart = uploadFiles;

/**
 * Get calculated year heat consumption.
 */
const getYearHeatConsumption = async (data) => {
    try {
        const response = await fetch(`${WP_API_BASE}/storages-simulator/calculation/year-heat-consumption`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data),
            signal: AbortSignal.timeout(120000)
        });

        if (!response.ok) {
            throw new Error(`HTTP error ${response.status}`)
        }

        const text = await response.text();
        if (!text) {
            throw new Error('Empty response body.')
        }
        return JSON.parse(text);

    } catch (error) {
        console.error("Fehler beim Abrufen der Year Heat Consumption:", error);
        throw error;
    }
};

const linkToPDF = async (id) => {
    return `${WP_API_BASE}/create-pdf/${id}`;
}

const createPDF = async (id) => {
    try {
        const response = await fetch(`${WP_API_BASE}/create-pdf/${id}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            signal: AbortSignal.timeout(120000)
        });

        if (!response.ok) {
            throw new Error(`HTTP error ${response.status}`)
        }

        const blob = await response.blob();
        if (blob.type !== "application/pdf") {
            throw new Error("Received file is not a PDF.");
        }
        const pdfData = await blob.arrayBuffer();
        return pdfData;

    } catch (error) {
        console.error("Fehler beim Erstellen des PDF:", error);
        throw error;
    }
};

export {
    sendSimulationData,
    fetchSimulationData,
    fetchConfiguratorData,
    uploadFiles,
    uploadFilesMultiPart,
    getYearHeatConsumption,
    getBatteryTypes,
    getStorageConfigList,
    linkToPDF,
    createPDF
};
